import { Injectable } from '@angular/core';
import { HttpClient } from '../shared/wrappers/HttpClient';
import { LocalStorage } from "../shared/wrappers/LocalStorage";
import { ToastsManager } from "ng2-toastr";
import { Router } from '@angular/router';


@Injectable()
export class AuthService {
    private endPoint = '/auth';
    constructor(private httpClient: HttpClient,
        private localStorage: LocalStorage,
        private toastManager: ToastsManager,
        private router: Router
        ) { }

    async auth(login) {
        const res = await this.httpClient.post(this.endPoint + '/common', login);
        if (res.success)
            this.localStorage.save(res.user, 'user');
        return res;
    }

    async oauthOffice365(){
        let res = await this.httpClient.get(`${this.endPoint}/oauth/365`);
        return res.url;
    }

    async refreshToken(username){
        return await this.httpClient.post(`${this.endPoint}/refresh-token`, username);
    }
}



// WEBPACK FOOTER //
// ./src/app/services/auth.service.ts